import PaintPurchaseOrdersWorkspace from '../../placeholders/PaintPurchaseOrdersWorkspace';

export default PaintPurchaseOrdersWorkspace;
